import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { PreviewEmailContentSubjectProps } from '../../../../../../types';

export const PreviewEmailContentSubject: React.FC<PreviewEmailContentSubjectProps> = ({ text }) => {
	return (
		<div className="mb-2 px-4 lg:mb-4">
			<Text variant="heading" size="small" className="m-0 leading-6">
				{text}
			</Text>
		</div>
	);
};
